<template>
  <div class="rt-detail-item">
    <div v-if="title" class="detail-item-header">
      <div class="detail-item-icon">
        <rt-icon :name="icon" :size="18"></rt-icon>
      </div>
      <span class="detail-item-title">{{ title }}</span>
      <div class="detail-item-btns"><slot name="btn" /></div>
    </div>
    <div class="detail-item-content"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'RtDetailItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less">
.rt-detail-item {
  background: #f5f7fa;
  margin-bottom: 10px;
  // padding: 16px 20px;
  .detail-item-header {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    background: #fff;
    .detail-item-icon {
      background: #0099ff;
      color: #fff;
      border-radius: 2px;
      margin-right: 16px;
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .rt-icon {
        line-height: 1;
      }
    }
    .detail-item-title {
      font-size: 16px;
      color: #143e81;
      font-weight: 500;
    }
    .detail-item-btns {
      // position: absolute;
      margin-left: auto;
    }
  }
  .detail-item-content {
    padding: 16px 20px;
  }
  // & + & {
  //   margin-top: 20px;
  // }
}
</style>



// WEBPACK FOOTER //
// rtDetailItem.vue?7590b68e